export default "__VITE_ASSET__Dsh1X1sP__"